var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showMessageInPlanView)?_c('div',{staticClass:"alert alert-expired-plan alert-address-bold",attrs:{"role":"alert"}},[_vm._v("\n        "+_vm._s(_vm.showMessageInPlanView)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }